import { useAtomValueRawSync } from 'jotai';
import { useEffect } from 'react';

import { contractReporter } from '@/api/contractReporter';
import { serverGateAtom } from '@/state/api/serversAtoms';
import type { Store } from '@/types/store';

/**
 * Grades what each media_server sends by `store`'s update reports, for as long as the calling
 * component is mounted. Reading the gate keeps the reports loaded and polled.
 */
export function useServerUpdateGate(store: Store): void {
    const gate = useAtomValueRawSync(serverGateAtom, { store });
    useEffect((): void => {
        contractReporter.setServerGate(gate);
    }, [gate]);
}
